import axios from "axios";

import { getReviewerTrainingEducationSignups } from "./user";
import { getAuthHeader } from "../headers";

// ===================================================================================
//  GET TRAINING SESSIONS
// ===================================================================================
export const trainingEducationLoading = () => {
	return {
		type: "TRAINING_EDUCATION_ARE_LOADING"
	};
};

export const trainingEducationError = error => {
	return {
		type: "TRAINING_EDUCATION_HAS_ERROR",
		error
	};
};

export const trainingEducationSuccess = data => {
	return {
		type: "TRAINING_EDUCATION_SUCCESS",
		data
	};
};

export function getTrainingEducation(isAdmin = false) {
	return (dispatch, getState) => {
		dispatch(trainingEducationLoading());

		const params = { language: process.env.REACT_APP_LANGUAGE };

		return axios
			.get(process.env.REACT_APP_API_URL + "training-sessions", {
				headers: getAuthHeader(getState().user, isAdmin),
				params
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingEducationError(response.data.errors));
				} else {
					dispatch(trainingEducationSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(trainingEducationError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  SIGNUP
// ===================================================================================
export const trainingEducationSignupLoading = () => {
	return {
		type: "TRAINING_EDUCATION_SIGNUP_IS_LOADING"
	};
};

export const trainingEducationSignupError = error => {
	return {
		type: "TRAINING_EDUCATION_SIGNUP_HAS_ERROR",
		error
	};
};

export const trainingEducationSignupSuccess = data => {
	return {
		type: "TRAINING_EDUCATION_SIGNUP_SUCCESS",
		data
	};
};

export const trainingEducationSignupReset = () => {
	return {
		type: "TRANING_EDUCATION_SIGNUP_RESET"
	};
};

export const signupReviewerToTrainingEducation = item => {
	return (dispatch, getState) => {
		dispatch(trainingEducationSignupLoading());

		const params = {
			id: item.id,
			language: process.env.REACT_APP_LANGUAGE
		};

		return axios
			.post(process.env.REACT_APP_API_URL + "training-education/signup", params, {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingEducationSignupError(response.data.errors));
				} else {
					dispatch(trainingEducationSignupSuccess(response.data));

					// Update reviewer's data in the store
					dispatch(getReviewerTrainingEducationSignups(response));

					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(trainingEducationSignupError(err.response.data.message));
			});
	};
};

// ===================================================================================
//  CANCEL
// ===================================================================================
export const trainingEducationCancelLoading = () => {
	return {
		type: "TRAINING_EDUCATION_CANCEL_IS_LOADING"
	};
};

export const trainingEducationCancelError = error => {
	return {
		type: "TRAINING_EDUCATION_CANCEL_HAS_ERROR",
		error
	};
};

export const trainingEducationCancelSuccess = data => {
	return {
		type: "TRAINING_EDUCATION_CANCEL_SUCCESS",
		data
	};
};

export const trainingEducationCancelReset = () => {
	return {
		type: "TRANING_EDUCATION_CANCEL_RESET"
	};
};

export const cancelReviewerTrainingEducation = item => {
	return (dispatch, getState) => {
		dispatch(trainingEducationCancelLoading());

		const params = { id: item.id, language: process.env.REACT_APP_LANGUAGE };

		return axios
			.post(process.env.REACT_APP_API_URL + "training-education/cancel-signup", params, {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingEducationCancelError(response.data.errors));
				} else {
					dispatch(trainingEducationCancelSuccess(response.data));

					// Update reviewer's data in the store
					dispatch(getReviewerTrainingEducationSignups(response));

					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(trainingEducationCancelError(err.response.data.message));
			});
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/trainingEducation.js